import React, { useState } from 'react';
import { Form, Button } from 'antd';
import { useDispatch } from 'react-redux';
import { submitUserDetauls } from '../../redux/auth/authAction';
import InputField from '../common/InputField';

const Login = () => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);


  const onFinish = values => {
    setLoading(true);
    Promise.resolve(dispatch(submitUserDetauls(values)))
      .finally(() => setLoading(false));
  };

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };

  const rules = [
    {
      required: true,
      message: 'This field is required!'
    }
  ];

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <div className="login-header-title">
            <span className="ms-blue">million spaces</span>
            <br />
            <span className="admin-portal">Admin Portal</span>
          </div>
        </div>
        <Form
          className="login-form"
          name="login"
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <InputField name={'username'} label={'User Name'} rules={rules} autoComplete="username" />
          <InputField
            typeOfField="password"
            name={'password'}
            label={'Password'}
            rules={rules}
            autoComplete="current-password"
          />
          <Form.Item className="btn-wrapper">
            <Button
              type="primary"
              htmlType="submit"
              block
              size="large"
              loading={loading}
              style={{ width: '100%', margin: '0 auto', display: 'block' }}
            >
              {loading ? 'Signing In...' : 'Sign In'}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Login;
